import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      user: JSON.parse(localStorage.getItem('tpuser')),
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    //   if(this.state.menu){
    //     this.setState({menu: false})
    //   }else{
    //     this.setState({menu: true})
    //   }
    this.setState({ menu: !this.state.menu });
  }

  componentDidMount() {}

  render() {
    const visible = this.state.menu ? 'show' : '';

    return (
      <nav
        className='navbar navbar-expand-sm navbar-dark'
        style={{ background: '#000' }}>
        <div className='col-sm-12 col-lg-8 offset-lg-2'>
          <a className='navbar-brand' href='/'>
            Test de Personalidad - Universidad Mayor
          </a>
          <button
            className='navbar-toggler float-right collapsed'
            type='button'
            data-toggle='collapse'
            data-target='#navbarsExample11'
            aria-expanded='false'
            aria-label='Toggle navigation'
            onClick={this.toggleMenu}>
            <span className='navbar-toggler-icon'></span>
          </button>
          <div
            className={
              'collapse navbar-collapse justify-content-end ' + visible
            }>
            <ul className='navbar-nav media-nav'>
              <li className='nav-item' onClick={this.toggleMenu}>
                <a className='nav-link' href='/test'>
                  Toma el test
                </a>
              </li>
              <li className='nav-item' onClick={this.toggleMenu}>
                <Link to='/personalities' className='nav-link'>
                  Conoce los tipos
                </Link>
              </li>
              {localStorage.getItem('tpuser') && (
                <li className='nav-item' onClick={this.toggleMenu}>
                  <Link to='/user' className='nav-link'>
                    Mi perfil
                  </Link>
                </li>
              )}
              {localStorage.getItem('tpuser') && (
                <li className='nav-item' onClick={this.toggleMenu}>
                  <Link to='/logout' className='nav-link'>
                    Salir
                  </Link>
                </li>
              )}
              {this.state.user && this.state.user.role == 'admin' && (
                <li className='nav-item' onClick={this.toggleMenu}>
                  <Link to='/admin/users' className='nav-link'>
                    Usuarios
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu.jsx